module.exports = __webpack_public_path__ + "img/individual_weddingrings_ring@2x.b00215f.webp";